<template>
  <div class="article-box">
     <el-breadcrumb class="bread-box" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">主页</el-breadcrumb-item>
      <el-breadcrumb-item>{{ routerName }}</el-breadcrumb-item>
    </el-breadcrumb>
     <el-row class="rich-content-box">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <h2 class="title-name">{{currentDataContent.title}}</h2>
          <p class="flex-box">
            <span>来源：{{currentDataContent.source}}</span>
            <span>作者：{{currentDataContent.author}}</span>
            <span>时间：{{currentDataContent.uTime}}</span>
          </p>
          <div class="content-box" v-html="currentDataContent.content" />
        </el-col>
      </el-row>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  export default {
    name: 'article',
    data() {
      return {
        routerName: this.$route.name,
        articleId: this.$route.params.articleId,
        currentDataContent: ''
      }
    },
    created () {
      this.getRichTextContent({id: this.articleId}).then(res => {
        if (res.success) {
          console.log(res.data, '66666666666666======data');
          this.currentDataContent = res.data;
        }
      })
    },
    methods: {
      ...mapActions([
        'getRichTextContent'
      ]),
    }
  }
</script>

<style lang="less">
.article-box {
  width: 100%;
      // 富文本
    .rich-content-box {
      padding: 0.24rem;
      line-height: 0.5rem;
      margin-bottom: 1rem;
    }
    .title-name {
      text-align: center;
      font-size: 0.4rem;
    }
    .flex-box {
      display: flex;
      justify-content: space-around;
      font-size: 0.22rem;
      color: #949494;
    }
    .content-box {
      font-size: 0.24rem;
    }
}
</style>
